import { backgroundJobsAtom } from "./backgroundJobs";
import moment from "moment/moment";
import { selectAtom } from "jotai/utils";
import { BackgroundJob } from "@/model";

export const sortedBackgroundJobsAtom = selectAtom<BackgroundJob[], BackgroundJob[]>(
    backgroundJobsAtom,
    (backgroundJobs) => {
        return backgroundJobs
            .sort((prev, next) => {
                return moment(next.created_at).diff(moment(prev.created_at));
            });
    }
);
